"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.common = void 0;
exports.common = {
    min: "мин.",
    m: "м",
    h: "ч",
    kb: "Кб",
    mb: "Мб",
    bytes: "байт",
    today: "сегодня",
    yesterday: "вчера",
    tomorrow: "завтра",
    phoneNumber: "Номер телефона",
    required: "Поле обязательно для заполнения",
    maxLength: "Достигнуто ограничение на количество символов",
    phoneError: "Телефон указан не верно",
    wrongEmail: "Некорректный адрес электронная почты",
    wrongURL: "Некорректный адрес сайта",
    companyName: "Название компании",
    userName: "ФИО",
    email: "Электронная почта",
    confirm: "Подтвердить",
    description: "Описание",
    delete: "Удалить",
    cancel: "Отменить",
    color: "Цвет",
    costMin: "Цена от",
    costMax: "Цена до",
    workingDays: "Рабочие дни",
    monday: "Понедельник",
    tuesday: "Вторник",
    wednesday: "Среда",
    thursday: "Четверг",
    friday: "Пятница",
    saturday: "Суббота",
    sunday: "Воскресение",
    break: "Перерыв",
    address: "Адрес",
    cityPhone: "Городской телефон",
    cellPhone: "Мобильный телефон",
    URL: "Сайт",
    skype: "Skype",
    whatsApp: "WhatsApp",
    telegram: "Telegram",
    viber: "Viber",
    ICQ: "ICQ",
    facebook: "Facebook",
    twitter: "Twitter",
    instagramm: "Instagramm",
    youTube: "YouTube",
    vk: "ВКонтакте",
    od: "Одноклассники",
    defaultPlaceholderTitle: "Здесь еще ничего нет",
    searchPlaceholder: "Поиск по адресу",
    apply: "Применить",
    reset: "Сбросить",
    timeRangeStart: "с",
    timeRangeEnd: "по",
    numberRangeStart: "от",
    numberRangeEnd: "до",
    notSet: "Не выбрано",
    close: "Закрыть",
    add: "Добавить",
    save: "Сохранить",
    editAction: "Редактировать",
    addFile: "Перетащите файл на эту область для загрузки или нажмите “+” для выбора файла",
    addFileErrorLimit: "Можно добавить только 1 файл",
    addFileErrorType: "Некорректный тип файла",
    addFileErrorSize: "Слишком большой файл",
    addFileRequirements: "Требования к файлам",
    addFileRemove: "Удалить изображение",
    copyImageUrl: "Скопировать ссылку на избражение",
    approve: "Утвердить",
    reject: "Отклонить",
    selected: "выбрано",
    nothingFound: "Ничего не найдено",
    toSettings: "В настройки",
    id: "Id",
    platform: "Платформа",
    role: "Роль",
    admin: "Администратор",
    user: "Пользователь",
    moderator: "Модератор",
    fromPage: "из",
    morePage: "более",
    nextPage: "След.",
    prevPage: "Пред.",
    search: "Поиск",
    loading: "Загрузка...",
    region: "Регион",
    allRegions: "Все регионы",
    pickRegion: "Выберите регион",
};
//# sourceMappingURL=common.js.map